import React, { useState, useCallback } from 'react';
import { AIOptionWizard } from './screens/AIOptionWizard';
import { ChatPanel } from './components/ChatPanel';
import { ChatSessionState } from './services/api';
import type { WizardStep } from './components/Stepper';
import './App.css';

const VALID_STEPS: Set<string> = new Set([
  'ai-option', 'ai-model', 'sai-details', 'approach',
  'algorithm', 'ml-config', 'training', 'results',
  'existing-model', 'existing-parameters', 'existing-results', 'visualize',
]);

const DEFAULT_SESSION_STATE: ChatSessionState = {
  sai_file_id: null,
  sai_file_name: null,
  model_index: null,
  model_name: null,
  current_page: null,
  approach: null,
  selected_algorithm: null,
  selected_model_mode: null,
};

function App() {
  const [sessionState, setSessionState] = useState<ChatSessionState>(DEFAULT_SESSION_STATE);
  const [navigateStep, setNavigateStep] = useState<WizardStep | null>(null);
  const [navigateResultData, setNavigateResultData] = useState<any>(null);

  const handleChatNavigate = useCallback((step: string, resultData?: any) => {
    if (VALID_STEPS.has(step)) {
      setNavigateResultData(resultData || null);
      setNavigateStep(step as WizardStep);
    }
  }, []);

  return (
    <div className="App">
      <AIOptionWizard
        sessionState={sessionState}
        onSessionStateChange={setSessionState}
        navigateStep={navigateStep}
        navigateResultData={navigateResultData}
        onNavigateHandled={() => { setNavigateStep(null); setNavigateResultData(null); }}
      />
      <ChatPanel sessionState={sessionState} onSessionStateChange={setSessionState} onNavigate={handleChatNavigate} />
    </div>
  );
}

export default App;
